import { del, getJson, patchJson, postJson, putJson } from 'utils/http';

import { ApiApplicantProfile } from './types/ApiApplicantProfile';
import { ApiWorkHistoryJob } from './types/ApiWorkHistoryJob';

export type ApiApplicantProfileResponse = {
  resumeId: string | null;
  isRecruitable: boolean | null;
  applicantProfile: ApiApplicantProfile | null;
};

const emptyProfile = {
  resumeId: null,
  isRecruitable: null,
  workHistoryJobs: [],
  skills: [],
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function mapProfileResponse({ applicantProfile }: any) {
  const {
    resumeS3FileId: resumeId,
    isRecruitable,
    ...profile
  } = applicantProfile || emptyProfile;
  return {
    resumeId,
    isRecruitable,
    applicantProfile: profile,
  };
}

export function apiFetchApplicantProfile(): Promise<ApiApplicantProfileResponse> {
  return getJson('/data/userdashboard/applicant-profile/profile').then(
    mapProfileResponse,
  );
}

export function apiUpdateApplicantProfile(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: Record<string, any>,
): Promise<ApiApplicantProfileResponse> {
  return patchJson(
    '/data/userdashboard/applicant-profile/profile',
    values,
  ).then(mapProfileResponse);
}

export function apiAddWorkHistoryJob(
  job: ApiWorkHistoryJob,
): Promise<ApiApplicantProfileResponse> {
  return postJson(
    '/data/userdashboard/applicant-profile/work-history/jobs',
    job,
  ).then(mapProfileResponse);
}

export function apiEditWorkHistoryJob(
  id: string,
  job: ApiWorkHistoryJob,
): Promise<ApiApplicantProfileResponse> {
  return putJson(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
    job,
  ).then(mapProfileResponse);
}

export function apiDeleteWorkHistoryJob(
  id: string,
): Promise<ApiApplicantProfileResponse> {
  return del(
    `/data/userdashboard/applicant-profile/work-history/jobs/${id}`,
  ).then(mapProfileResponse);
}

export function apiFetchUserByEmail(email: string) {
  return getJson(
    `/data/users/by-email?email=${encodeURIComponent(email)}`,
  ).then(
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    (result) => result && result.userExists,
  );
}
